import { useDispatch, useSelector } from "react-redux";
import { setLoadingConfigurations } from "@redux/slices/appStateSlice";

const useSplashScreenController = () => {
  const dispatch = useDispatch();
  const isLoadingConfigurations = useSelector(
    (state: any) => state.appState.isLoadingConfigurations
  );

  const showSplashScreen = () => dispatch(setLoadingConfigurations(true));
  const hideSplashScreen = () => dispatch(setLoadingConfigurations(false));

  return { isLoadingConfigurations, showSplashScreen, hideSplashScreen };
};

export { useSplashScreenController };
